import { Box } from '@mui/system';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Typography, useTheme, Button, Avatar, Paper } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function RegisterCheckoutReturn() {
  const [status, setStatus] = useState(null);
  const theme = useTheme();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const success = urlParams.get('success');

    if (success === 'true') {
      setStatus('complete');
    } else if (success === 'false') {
      setStatus('error');
    } else {
      setStatus('error');
    }
  }, [location.search]);

  return (
    <Paper
      elevation={3}
      sx={{
        height: { xs: '80vh', sm: '80vh', md: '80vh', lg: '80vh' },
        padding: 4,
        marginTop: { xs: '100px', sm: '60px', md: '40px', lg: '20px' },
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '85vh',
          px: { xs: 2, md: 4 },
          overflow: 'hidden',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        {status === 'error' && (
          <>
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            >
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  bgcolor: theme.palette.error.main,
                  mb: 3,
                }}
              >
                <ErrorIcon sx={{ fontSize: 80, color: '#fff' }} />
              </Avatar>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              <Typography variant="h4" gutterBottom fontWeight="bold">
                Registrierung fehlgeschlagen
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 4, maxWidth: 500 }}
              >
                Bei der Erstellung Ihres Abonnements ist ein Fehler aufgetreten.
                Bitte kontaktieren Sie den Support oder versuchen Sie es später
                erneut.
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.6 }}
            >
              <Button
                variant="contained"
                color="error"
                href="/"
                sx={{ px: 4, py: 1.5 }}
              >
                Zurück zur Startseite
              </Button>
            </motion.div>
          </>
        )}

        {status === 'complete' && (
          <>
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            >
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  bgcolor: theme.palette.success.main,
                  mb: 3,
                }}
              >
                <CheckCircleIcon
                  sx={{
                    fontSize: 80,
                    color: '#fff',
                  }}
                />
              </Avatar>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              <Typography variant="h4" gutterBottom fontWeight="bold">
                Anmeldung erfolgreich!
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.6 }}
            >
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 4, maxWidth: 500 }}
              >
                Vielen Dank für Ihre Anmeldung! Sie haben eine E-Mail erhalten,
                um die Zwei-Faktor-Authentifizierung einzurichten. Sobald dies
                abgeschlossen ist, wird Ihr Account aktiviert und Sie können
                unsere Produkte nutzen.
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.6 }}
            >
              <Button
                variant="contained"
                color="success"
                href="/organizer"
                sx={{ px: 4, py: 1.5 }}
              >
                Zum Login
              </Button>
            </motion.div>
          </>
        )}
      </Box>
    </Paper>
  );
}
